import MainLayout from '@layouts/main-layout/main-layout';
export default MainLayout;
